import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";
import { ButtonV2 } from "../../Atoms/ButtonV2";
import { TipoPagamento } from "../../../enums/tipoPagamento";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";
import { IFaturaDTO } from "../../../types/pagamento";
import { maskMoney } from "../../../utils/masks";
import { getStatusColorClass } from "./getStatusColorClass";
import { getStatusLabel } from "./getStatusLabel";

interface IFaturaRowV2Props {
  fatura: IFaturaDTO;
  isOdd?: boolean;
  onVerFatura: (fatura: IFaturaDTO) => void;
}

export const FaturaRowV2 = ({
  fatura,
  isOdd,
  onVerFatura,
}: IFaturaRowV2Props) => {
  const formaPagamento = fatura?.boleto
    ? TipoPagamento.BOLETO
    : TipoPagamento.PIX;

  const dataRealizacao = fatura?.dataAutorizacao
    ? dayjs(fatura.dataAutorizacao).format("DD/MM/YYYY")
    : "---";

  return (
    <div
      className={twMerge(
        "flex flex-col gap-2 p-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6",
        isOdd ? "bg-[#e8e8e8] rounded-[10px]" : "bg-[#f7f7f7ee]",
      )}
    >
      <p className="text-xs font-extrabold text-[#2d2d2d]">
        DATA DE REALIZAÇÃO:{" "}
        <span className="font-normal text-[#9d9d9d]">{dataRealizacao}</span>
      </p>

      <p className="text-xs font-extrabold text-[#2d2d2d]">
        FORMA DE PAGAMENTO:{" "}
        <span className="font-normal text-[#9d9d9d]">{formaPagamento}</span>
      </p>

      <p className="text-xs font-extrabold text-[#2d2d2d]">
        VALOR:{" "}
        <span className="font-normal text-[#9d9d9d]">
          {maskMoney(fatura?.valorTotal / 100)}
        </span>
      </p>

      <p className="text-xs font-extrabold text-[#2d2d2d]">
        STATUS:{" "}
        <span
          className={twMerge(
            "font-extrabold",
            getStatusColorClass(fatura?.status),
          )}
        >
          {getStatusLabel(fatura?.status)}
        </span>
      </p>

      {fatura?.status === StatusPagamentoEnum.pending && (
        <ButtonV2
          type="button"
          onClick={() => onVerFatura(fatura)}
          className="h-auto min-w-0 rounded-[10px] bg-[#20332f] px-3 py-1 text-sm"
        >
          Ver Fatura
        </ButtonV2>
      )}
    </div>
  );
};
